import Form from '../../../../../form_builder_2/form';
import AnalyticsHelper from '../../../../../utils/analytics-helper';

export default class PreferredDealerSubview {
    constructor(parent) {
        this.parent = parent;
        this.el = parent.el.querySelector('.preferred-dealer-view');
        this.input = this.el.querySelector('[name="preferred_dealer"]');
        this.dealerInput = this.el.querySelector('.dealer_search_input');
        this.form = new Form(this.el.querySelector('.preferred-dealer-form'), {
            onSuccess: this.onSuccess.bind(this),
            onError: this.onError.bind(this),
        });
        this.bind();
    }

    bind() {
        window.HONDA.MyAccount2.addEventListener('login', () => this.update());
    }

    onSuccess(result) {
        this.form.showSuccess();
        this.form.fieldBySelector('.form_field_dealer_search')?.reset(null, false);
        window.HONDA.MyAccount2.client.flushCache('personal-details');
        window.HONDA.MyAccount2.onLogin();
        this.analyticsPush(result);
    }

    onError(result) {
        this.form.showError();
        this.form.hideSuccess();
        this.analyticsPush(result);
    }

    analyticsPush(result) {
        AnalyticsHelper.push({
            event:'find a dealer',
            eventCategory:'find_a_dealer',
            eventAction:'save dealer',
            eventLabel:`${dataLayer[0].productCategory}|My account profile details|${this.dealerInput.value}|Save Preferred Dealer|internal|#`,
            actionType:'save dealer',
            businessUnit: dataLayer[0].productCategory,
            moduleName:'My account profile details',
            FADSearchText:`${this.dealerInput.value}`, 
            clickText:'Save Preferred Dealer',
            clickType:'internal', 
            destinationURL: '',
        });
    }

    async update() {
        const details = await window.HONDA.MyAccount2.client.getPersonalDetails();
        const dealer = details?.preferredDealercode;
        if(dealer) {
            this.input.value = dealer;
            this.input.dispatchEvent(new Event('change'));
        }
    }
}